import { LitElement, html, css } from 'lit'
import { customElement, query, state } from 'lit/decorators.js'

@customElement('setting-let')
export class SettingLet extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
        margin: var(--setting-let-margin);
        padding: var(--setting-content-padding);
        background-color: var(--md-sys-color-on-primary);
        border-radius: var(--setting-let-border-radius);
        border: var(--setting-let-border);
        text-transform: capitalize;
      }

      slot {
        display: block;
      }
      slot[name='title'] {
        margin-bottom: var(--spacing-medium);
        border-bottom: 1px dotted rgba(var(--md-sys-color-primary), 0.5);
      }
      slot[name='title']::slotted(*) {
        color: var(--md-sys-color-primary);
        font: var(--setting-title-font);
      }

      slot[name='content']::slotted(*) {
        color: var(--md-sys-color-on-surface);
        font: var(--setting-content-font);
      }
    `
  ]

  render() {
    return html`
      <slot name="title"></slot>
      <slot name="content"></slot>
    `
  }
}
